export const SUPPORTED_CONFIG_FILE_TYPES = {
  JSON: 'json',
  YAML: 'x-yaml',
};

export const SUPPORTED_PLATFORMS = {
  TS: 'Tradeshift',
  GO: 'Go',
};
